/** One entry of a search select: what it stands for and how it reads. */
export interface SearchSelectOption {
  id: string;
  label: string;
  /** A second, quieter line — where a contract lives, when it ran. */
  hint?: string | null;
}

/**
 * Whether an entry matches what somebody typed (UI-018).
 *
 * Every word has to turn up somewhere in the label or the hint, in any order
 * and anywhere inside a word, ignoring case — the rule the contract search on
 * the server applies too, so a picker does not answer one way when its list
 * is local and another when it is fetched. Locally an accent also counts as
 * its base letter ("Stanojevic" finds Stanojević); the server does not do
 * that yet.
 *
 * An empty term matches everything; the list starts open, not empty.
 */
export function matchesSearch(option: SearchSelectOption, term: string): boolean {
  const haystack = fold(`${option.label} ${option.hint ?? ''}`);
  return term
    .trim()
    .split(/\s+/)
    .filter((word) => word.length > 0)
    .every((word) => haystack.includes(fold(word)));
}

function fold(text: string): string {
  return text
    .normalize('NFD')
    .replace(/\p{Diacritic}/gu, '')
    .toLocaleLowerCase();
}
